module.exports = __webpack_public_path__ + "static/media/man.521cd05a.svg";